import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from'../Component/Header'
const Attendance = () => { 
    useEffect(() => {
        document.title = ' Attendance - Sacread Heart Kharagpur';  
    }, []); 
  return (
     <>
     <Header/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Academic</li>
                 <li>Attendance</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>Attendance</h1>
                    </div>
                </div>
                <div className="row">
                     <div className="col-12">
                     <ul className="list newlist">
                     <li> Regular attendance at school is in the interest of the students. It builds up a sense of devotion to duty and a habit for regularity and discipline. The students should arrive on time to the school. Parents co-operation is needed so that punctuality is ensured. 
                     </li>
                     <li> Students who have been absent from class must have the reason entered in the Regularity Record in the School Diary, stating briefly the case of the absence under absence column. A student who is absent for more then three days on account of illness should provide doctor’s certificate of fitness along with the prescription. In case of long illness, the Principal should be informed in writing. 
                     </li>
                     <li> Punctuality of School timing is very important. Late arrival to school is a break of discipline. A student who arrives late will not be permitted to enter the class in the first period, and lose his attendance for the day. Irregular attendance, habitual illness,disobedience or misconduct injurious to the moral tone of the school are sufficient reasons for adopting strict disciplinary measures which may even lead to dismissal of student from the school. Those whose attendance falls short of 85% may be debarred from appearing for the examination.
                     </li>
                     <li>Absence from class for birthdays, marriages, feasts, excursions in view of anticipating of extending school vacations or in order to study are not encouraged. If a student is absent for fifteen consecutive days his name may be struck off the rolls. 
                     </li>
                     <li> No child will be permitted to leave the school during class hours without special permission of the Principal and only if a written request from the parent is submitted. If a student is absent without leave for fiften consecutive days his name may be struck off the rolls. however the student tution fees will be charged. if needed minimium charge will be taken </li>
                     </ul>
 </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default Attendance

